import React,{useEffect,useState} from "react";
import { Col, Divider, Row } from 'antd';
import "./ShopResponsive.scss";
import HeaderDesktop from "../DesktopComponents/HeaderDesktop/HeaderDesktop";
import SliderDesktop from "../DesktopComponents/SliderDesktop/SliderDesktop";
import SingleBarDesktop from "../DesktopComponents/SingleBarDesktop/SingleBarDesktop";
import SingleBannerDesktop from "../DesktopComponents/SingleBannerDesktop/SingleBannerDesktop";
import {MyRecentMerchant} from "../Home/Sections";
import {Slider} from "../../Components";
import DualBarDesktop from "../DesktopComponents/DualBarDesktop/DualBarDesktop";
import ButtonListDesktop from "../DesktopComponents/ButtonListDesktop/ButtonListDesktop";
import TriadBigRightDesktop from "../DesktopComponents/TriadBigRightDesktop/TriadBigRightDesktop";
import ActualDesktop from "../DesktopComponents/ActualDesktop/ActualDesktop";
import {MultipleListDesktop} from "../DesktopComponents/MultipleListDesktop/MultipleListDesktop";
import {ProductRegalDesktop} from "../DesktopComponents/ProductRegalDesktop/ProductRegalDesktop";
import {ProductRegalNewDesktop} from "../DesktopComponents/ProductRegalDesktop/ProductRegalNewDesktop";
import ShopCategoryDesktop from "../DesktopComponents/ShopCategoryDesktop/ShopCategoryDesktop";
import FooterDesktop from "../DesktopComponents/FooterDesktop/FooterDesktop";
import DrShopHeader from "../../Components/DrShopHeader/DrShopHeader";
import ServiceSecDesktop from "../DesktopComponents/ServiceSecDesktop/ServiceSecDesktop";

const style = {
    background: '#0092ff',
    // padding: '8px 0',
};
function ShopResponsive ({merchant,homi,LinkDispatcher}){

    const [data,set_data] = useState([])

    useEffect(()=>{
        set_data(data)
    },[homi])

    return(
        <div>
            <div className="home-fixed-container">
                {/*<HeaderDesktop mId={merchant} active="shop"/>*/}
                <DrShopHeader/>
                {homi.map(item => {
                    switch (item.section_type) {
                        case 'home_header':
                            return (
                                <HeaderDesktop item={item} LinkDispatcher={LinkDispatcher}/>
                            )
                            break;
                        case 'slider':
                            return (
                                <SliderDesktop uid={item.uid} item={item} dispatch={LinkDispatcher}
                                               data={item.items}/>
                            )
                            break;
                    }})}
            </div>
            <div className="home-responsive-container">
                <div className="home-responsive-body">
                    {homi.map(item => {
                        switch (item.section_type) {
                            case 'shop_category_list':
                                return (
                                    <ShopCategoryDesktop merchant={merchant} item={item} LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            case 'single_bar':
                                return (
                                    <SingleBarDesktop item={item} LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            case 'single_banner':
                                return (
                                    <SingleBannerDesktop item={item} LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            case 'dual_bar':
                                return (
                                    <DualBarDesktop item={item} LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            case 'service_section':
                                return (
                                    <ServiceSecDesktop
                                        item={item}
                                        LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            case 'button_list':
                                return (
                                    <ButtonListDesktop item={item} LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            case 'triad_big_right':
                                return (
                                    <TriadBigRightDesktop item={item} LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            case 'actual_size_banner':
                                return (
                                    <ActualDesktop item={item} LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            case 'multiple_banner':
                                return (
                                    <MultipleListDesktop item={item} LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            case 'product_category':
                                return (
                                    <ProductRegalNewDesktop item={item} LinkDispatcher={LinkDispatcher}/>
                                )
                                break;

                        }})}
                </div>


            </div>
            <br/><br/>
            <FooterDesktop/>
        </div>
            )

}
export default  ShopResponsive
